module.exports = __webpack_public_path__ + "img/circle-sort-up.add02e79.svg";